import React from 'react';
import { getPathApp } from '../utils/util';
import PrivateRoute from './PrivateRoute';
import Container from '../containers/Container/Home/Container';
import Storage from '../containers/Container/Storage/Storage';
import Spawing from '../containers/Container/Spawning/Spawing';
import Config from '../containers/Container/Config/Config';
import Patio from '../containers/Container/Config/Patio/Home';
import UnloadLocation from '../containers/Container/Config/UnloadLocation/Home';
import AreaVirtual from '../containers/Container/Config/Patio/AreaVirtual/AreaVirtual';
import AreaVirtualInsert from '../containers/Container/Config/Patio/AreaVirtual/AreaVirtualInsert';

import PositionInsert from '../containers/Container/Config/Patio/Position/PositionInsert';
import PositionList from '../containers/Container/Config/Patio/Position/PositionList';

import UnloadLocationInsert from '../containers/Container/Config/UnloadLocation/UnloadLocationInsert';
import UnloadLocationList from '../containers/Container/Config/UnloadLocation/UnloadLocationList';

import CriticalPartsRegistration from '../containers/Container/Config/CriticalPartsRegistration/CriticalPartsRegistration';
import CriticalPartsList from '../containers/Container/Config/CriticalPartsRegistration/CriticalPartsList';
import CriticalPartsEmailList from '../containers/Container/Config/CriticalPartsRegistration/CriticalPartsEmailList';
import CriticalPartInsert from '../containers/Container/Config/CriticalPartsRegistration/CriticalPartInsert';

import IssuerInsert from '../containers/Container/Config/IssuerCodeRegistration/IssuerInsert';
import IssuerList from '../containers/Container/Config/IssuerCodeRegistration/IssuerList';
import IssuerCodeRegistration from '../containers/Container/Config/IssuerCodeRegistration/IssuerCodeRegistration';
import RegisterContainer from '../containers/Container/Config/RegisterContainer/RegisterContainer';
import ContainerInsert from '../containers/Container/Config/RegisterContainer/ContainerInsert';
import ContainerList from '../containers/Container/Config/RegisterContainer/ContainerList';

import ExecutionSchedule from '../containers/Container/Config/ExecutionCalculation/ExecutionSchedule';
import ExecutionScheduleList from '../containers/Container/Config/ExecutionCalculation/ExecutionScheduleList';
import ExecutionCalculation from '../containers/Container/Config/ExecutionCalculation/ExecutionCalculation';

import Demurrage from '../containers/Container/Demurrage/Demurrage';
import DemurrageRules from '../containers/Container/Demurrage/DemurrageRules/DemurrageRules';
import DemurrageMonitor from '../containers/Container/Demurrage/Monitor/Monitor';
import DemurrageAlerts from '../containers/Container/Demurrage/DemurrageAlerts/DemurrageAlerts';

import Search from '../containers/Container/Search/Search';

import Coverage from '../containers/Container/Coverage/Coverage';

import CoveragePartNumber from '../containers/Container/Coverage/CoveragePartNumber/Home';
import CoveragePartNumberList from '../containers/Container/Coverage/CoveragePartNumber/CoveragePartNumberList';
import CoveragePartNumberInsert from '../containers/Container/Coverage/CoveragePartNumber/CoveragePartNumberInsert';
import CoverageCalculationList from '../containers/Container/Coverage/CoverageCalculation/CoverageCalculationList';

import ContainerTypeInsert from '../containers/Container/Config/ContainerType/ContainerTypeInsert';
import ContainerTypeList from '../containers/Container/Config/ContainerType/ContainerTypeList';
import ContainerType from '../containers/Container/Config/ContainerType/ContainerType';
import ContainerSizeInsert from '../containers/Container/Config/ContainerSize/ContainerSizeInsert';
import ContainerSizeList from '../containers/Container/Config/ContainerSize/ContainerSizeList';
import ContainerSize from '../containers/Container/Config/ContainerSize/ContainerSize';

import PlantConfig from '../containers/Container/Config/PlantConfig/PlantConfig';
import BusinessHoursConfig from '../containers/Container/Config/BusinessHours/BusinessHoursConfig';

import MaritimeCompanyHome from '../containers/Container/Config/MaritimeCompany/MaritimeCompany';
import MaritimeCompanyInsert from '../containers/Container/Config/MaritimeCompany/MaritimeCompanyInsert';
import MaritimeCompanyList from '../containers/Container/Config/MaritimeCompany/MaritimeCompanyList';

import HarborHome from '../containers/Container/Config/Harbor/Harbor';
import HarborInsert from '../containers/Container/Config/Harbor/HarborInsert';
import HarborList from '../containers/Container/Config/Harbor/HarborList';

import FreeTimeHome from '../containers/Container/Config/FreeTime/FreeTime';
import FreeTimeInsert from '../containers/Container/Config/FreeTime/FreeTimeInsert';
import FreeTimeList from '../containers/Container/Config/FreeTime/FreeTimeList';

import UploadFilePackaging from '../containers/Container/Storage/UploadFile/UploadFile';
import StorageContainer from '../containers/Container/Storage/StorageContainer/StorageContainer';
import ChangeStatusContainer from '../containers/Container/Storage/ChangeStatusContainer/ChangeStatusContainer';
import UploadContainer from '../containers/Container/Storage/UploadContainer/UploadContainer';
import ChangeDatesContainer from '../containers/Container/Storage/ChangeDatesContainer/ChangeDatesContainer';
import ChangeStatusContainerList from '../containers/Container/Storage/ChangeStatusContainer/ChangeStatusContainerList';
import StatusSearch from '../containers/Container/Search/Status/StatusSearch';
import StatusDetail from '../containers/Container/Search/Status/StatusDetail';
import Mdr from '../containers/Container/Config/Mdr/Mdr';
import MdrList from '../containers/Container/Config/Mdr/MdrList';
import MdrInsert from '../containers/Container/Config/Mdr/MdrInsert';
import TransferContainer from '../containers/Container/Storage/TransferContainer/TransferContainer';
import ExplosionContainer from '../containers/Container/Search/Explosion/ExplosionContainer';
import AviexpContainer from '../containers/Container/Search/Aviexp/AviexpContainer';
import ContainerHistory from '../containers/Container/Search/ContainerHistory';
import PartNumber from '../containers/Container/Search/PartNumber/PartNumber';
import SpawningContainer from '../containers/Container/Spawning/SpawningContainer/SpawningContainer';
import StockPartNumber from '../containers/Container/Search/PartNumber/StockPartNumber';
import SpawningFull from '../containers/Container/Spawning/SpawningContainer/SpawningFull';

import MapYard from '../containers/Container/Storage/Map/MapYard';

import PartNumberSupplier from '../containers/Container/Storage/PartNumberSupplier/PartNumberSupplier';
import PartNumberSupplierList from '../containers/Container/Storage/PartNumberSupplier/PartNumberSupplierList';
import PartNumberSupplierInsert from '../containers/Container/Storage/PartNumberSupplier/PartNumberSupplierInsert';

let aux = 0;

const pathurl = getPathApp(window);
const ContainerRoute = [
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/spawing/container/full`} component={SpawningFull} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/spawing/container`} component={SpawningContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/spawning`} component={Spawing} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/partnumbersupplier/insert`} component={PartNumberSupplierInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/partnumbersupplier/list`} component={PartNumberSupplierList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/partnumbersupplier`} component={PartNumberSupplier} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/uploadContainer`} component={UploadContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/uploadFile`} component={UploadFilePackaging} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/transfer`} component={TransferContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/changeDates`} component={ChangeDatesContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/changeStatus`} component={ChangeStatusContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/changeStatusList`} component={ChangeStatusContainerList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/container`} component={StorageContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage/map`} component={MapYard} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/storage`} component={Storage} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/criticalpartsregistration/insert`} component={CriticalPartInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/criticalpartsregistration/list`} component={CriticalPartsList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/criticalpartsregistration/emails`} component={CriticalPartsEmailList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/criticalpartsregistration`} component={CriticalPartsRegistration} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/executioncalculation/insert`} component={ExecutionSchedule} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/executioncalculation/list`} component={ExecutionScheduleList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/issuercoderegistration/insert`} component={IssuerInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/issuercoderegistration/list`} component={IssuerList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/issuercoderegistration`} component={IssuerCodeRegistration} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/criticalpartsregistration`} component={CriticalPartsRegistration} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/executioncalculation`} component={ExecutionCalculation} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/registercontainer/insert`} component={ContainerInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/registercontainer/list`} component={ContainerList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/registercontainer`} component={RegisterContainer} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/position/insert`} component={PositionInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/position/list`} component={PositionList} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/unloadlocation/list`} component={UnloadLocationList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/unloadlocation/insert`} component={UnloadLocationInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/unloadlocation`} component={UnloadLocation} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/area/insert`} component={AreaVirtualInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/area`} component={AreaVirtual} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/patio`} component={Patio} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/containertype/insert`} component={ContainerTypeInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/containertype/list`} component={ContainerTypeList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/containertype`} component={ContainerType} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/containersize/insert`} component={ContainerSizeInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/containersize/list`} component={ContainerSizeList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/containersize`} component={ContainerSize} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/mdr/insert`} component={MdrInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/mdr/list`} component={MdrList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/mdr`} component={Mdr} />,


    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/plantconfig`} component={PlantConfig} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/businesshoursconfig`} component={BusinessHoursConfig} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/maritimecompany/list`} component={MaritimeCompanyList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/maritimecompany/insert`} component={MaritimeCompanyInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/maritimecompany`} component={MaritimeCompanyHome} />,


    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/harbor/list`} component={HarborList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/harbor/insert`} component={HarborInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/harbor`} component={HarborHome} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/freetime/list`} component={FreeTimeList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/freetime/insert`} component={FreeTimeInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config/freetime`} component={FreeTimeHome} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/config`} component={Config} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/demurrage/alerts`} component={DemurrageAlerts} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/demurrage/monitor`} component={DemurrageMonitor} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/demurrage/rules`} component={DemurrageRules} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/demurrage`} component={Demurrage} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/partnumber`} component={PartNumber} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/aviexp`} component={AviexpContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/stock`} component={StockPartNumber} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/explosion`} component={ExplosionContainer} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/status`} component={StatusSearch} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/statusdetail`} component={StatusDetail} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search/containerHistory`} component={ContainerHistory} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/search`} component={Search} />,


    <PrivateRoute key={aux += 1} path={`${pathurl}/container/coverage/calculation/list`} component={CoverageCalculationList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/coverage/partnumber/list`} component={CoveragePartNumberList} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/coverage/partnumber/insert`} component={CoveragePartNumberInsert} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/coverage/partnumber`} component={CoveragePartNumber} />,
    <PrivateRoute key={aux += 1} path={`${pathurl}/container/coverage`} component={Coverage} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/container`} component={Container} />,




];

export default ContainerRoute;

